<template>
  <div>
    <div class="stem" :class="'one-' + question.questionId">
      <span class="index">{{ idx }}.</span>
      <span class="type">({{ checkType(question.type) }})</span>
      <p class="question_title" v-html="question.question"></p>
      <b class="question_score">{{ question.score }}分</b>
      <b class="grade" v-show="alreadyDo">得分：{{ question.myScore }}分</b>
    </div>
    <div
      class="one_option"
      :class="{
        checked: isInArray(question.myAnswerList || [], i.tag),
        disabled: alreadyDo,
      }"
      v-for="i in question.optionList"
      :key="i.tag"
    >
      <div class="option" @click="chooseQuestion(i)"></div>
      <div class="option_text">
        <span style="margin-right: 5px">{{ i.tag }}.</span>
        <span v-html="i.option"></span>
      </div>
    </div>
    <p class="answer-row" v-if="!hideAnswer && question.answerList">
      正确答案：{{ question.answerList.join(",") }}
    </p>
  </div>
</template>

<script>
import { checkType } from "@/utils/index";
export default {
  name: "judge",
  props: {
    // 索引
    idx: {
      type: Number,
      default: null,
    },
    // 题目对象
    question: {
      type: Object,
      default: function () {
        return {};
      },
    },
    alreadyDo: Boolean,
    hideAnswer: Boolean,
  },
  data() {
    return {
      checkType,
    };
  },
  created() {
    this.question.myAnswerList = this.question.myAnswerList || [];
  },
  methods: {
    // 判断是否已存在在数组中
    isInArray(arr, item) {
      return arr.some((e) => e == item);
    },
    // 选择正确答案
    chooseQuestion(item) {
      if (this.alreadyDo) return;
      this.question.myAnswerList = [];
      this.question.myAnswerList.push(item.tag);
    },
  },
};
</script>

<style lang="less" scoped>
.stem {
  position: relative;
  margin: 20px 0;

  .index {
    display: inline-block;
    margin-top: 3px;
    font-size: 16px;
    vertical-align: top;
  }
  .type {
    display: inline-block;
    margin: 0 5px;
    color: #969696;
    vertical-align: top;
  }

  .question_title {
    display: inline-block;
    max-width: 83%;
    font-size: 16px;
    color: #333;
    vertical-align: top;
  }

  .question_score {
    display: inline-block;
    margin-left: 10px;
    color: #999;
    font-size: 14px;
    vertical-align: top;
  }
  .grade {
    position: absolute;
    top: 0;
    right: -20px;
    color: #ff0000;
  }
}

.one_option {
  margin-bottom: 20px;
  &.disabled {
    .option {
      cursor: not-allowed;
      background: #f5f7fa;
    }
  }
  &.checked {
    .option {
      position: relative;
      background: #1890ff;
      color: #fff;
      border-color: #1890ff !important;
      transition: all 0.3s ease;

      &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        content: "●";
      }
    }

    .option_text {
      color: #1890ff;
    }
  }

  .option {
    display: inline-block;
    width: 20px;
    text-align: center;
    line-height: 20px;
    height: 20px;
    border-radius: 2px;
    border: 1px solid #bbb;
    border-radius: 50%;
    vertical-align: top;
    cursor: pointer;
  }

  .option_text {
    display: inline-block;
    margin-left: 16px;
    font-size: 16px;
    transition: all 0.3s ease;

    img {
      margin: 0 5px !important;
      max-height: 30px !important;
    }
  }
}
.answer-row {
  color: #67c23a;
}
</style>